import { render } from "./Appointments.vue?vue&type=template&id=74b7c82a&scoped=true&ts=true"
import script from "./Appointments.vue?vue&type=script&lang=ts"
export * from "./Appointments.vue?vue&type=script&lang=ts"

import "./Appointments.vue?vue&type=style&index=0&id=74b7c82a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b7c82a"]])

export default __exports__